import { get } from './index';

export const search = (year, month) => {
    return get("api/delivery/" + year + "/" + month);
}

export const getById = (id) => {
    return get("api/delivery/" + id);
}